export const serviceIdMap = new Map();

export const ServiceIds = {
    // LeagueXI Football service IDs
    free: "football-free",
    daily: "mtn-fanclash-leaguexi-daily-01",
    weekly: "mtn-fanclash-leaguexi-weekly-01",
    monthly: "mtn-fanclash-leaguexi-monthly-01",
}

serviceIdMap.set(ServiceIds.free, 1);
serviceIdMap.set(ServiceIds.daily, 2);
serviceIdMap.set(ServiceIds.weekly, 3);
serviceIdMap.set(ServiceIds.monthly, 4);

const legacyServiceMap = new Map([
    // Add legacy mappings if needed in future
]);

export function getLegacyId(serviceKey) {
    if (legacyServiceMap.has(serviceKey)) {
        return legacyServiceMap.get(serviceKey);
    }
    return serviceKey;
}

export const availableLeagues = [
    {league: 'epl', leagueName: 'English Premiere League'},
    {league: 'liga', leagueName: 'La Liga'},
];

export const sportsBundles = {
    daily:   { label: 'Bundle_Sports_D', price: 'R2/day',    depId: 11398, depUrl: 'http://doi.mtndep.co.za/service/11398', landerUrl: 'http://playbundles.mtn.co.za/lander/sports?s=Bundle_Sports_D' },
    weekly:  { label: 'Bundle_Sports_W', price: 'R10/week',  depId: 11397, depUrl: 'http://doi.mtndep.co.za/service/11397', landerUrl: 'http://playbundles.mtn.co.za/lander/sports?s=Bundle_Sports_W' },
    monthly: { label: 'Bundle_Sports_M', price: 'R30/month', depId: 11396, depUrl: 'http://doi.mtndep.co.za/service/11396', landerUrl: 'http://playbundles.mtn.co.za/lander/sports?s=Bundle_Sports_M' },
};

export const defaultSportsBundle = sportsBundles.daily;

export const leagueXiService = {
    serviceName: 'PR_LeagueXI',
    depId: 11457,
    subscribeUrl: 'http://doi.mtndep.co.za/service/11457',
};
